import React, { useCallback, useState } from 'react'

export const useHeaderParameterManager = () => {

    const [taskHeaders, setTaskHeaders] = useState([])

    const [taskHeadersInitialized, setTaskHeadersInitialized] = useState(false);

    const addTaskHeader = useCallback(() => {
        setTaskHeaders((prevState) => [...prevState, ["", ""]])
    }, [])

    const updateTaskHeader = useCallback((index, val) => {
        setTaskHeaders((prevState) => {
            let temp = [...prevState];
            temp[index] = val
            return temp
        })
    }, [])

    const deleteTaskHeader = useCallback((index) => {
        setTaskHeaders((prevState) => {
            return prevState.filter((_, idx) => idx !== index)
        })
    }, [])



    return { taskHeaders, setTaskHeaders, addTaskHeader, updateTaskHeader, deleteTaskHeader, taskHeadersInitialized, setTaskHeadersInitialized }

}
